(function(){
	
	  //globals for carousel
	  // Actually, making something named currentIndex and transformProp, which are generic terms, global opens up the possibility that this will interfere with something somewhere else. 
	  // This functionality is now wrapped in an SEAF to seal off functionality. The carouselInit function is exported to window
	  var transformProp = "";
	  var currentIndex = 8;
	
	
	  //Initialise carousel
	  var carouselInit = function() {
		  if(typeof window.carouselInitHasAlreadyBeenCalled !== "undefined")
			  console.error('carouselInit called multiple times.');
			  
		  window.carouselInitHasAlreadyBeenCalled = true;
	    transformProp = Modernizr.prefixed('transform');
	    var carousel = new Carousel3D( document.getElementById('carousel'));
	
	
	    var navButtons = document.querySelectorAll('#menuDiv .toggle-carousel');
	    var onNavButtonClick = function( event ){
	      var increment = parseInt( event.target.getAttribute('data-increment') );
	      carousel.rotation += carousel.theta * increment * -1;
	      carousel.transform();
	      carousel.highlightNav(increment);
	    };
	
	    carousel.panelCount = parseInt(8);
	    carousel.modify();
	
	    for (var i=0; i < 2; i++) {
		    // 
	      navButtons[i].addEventListener( 'click', onNavButtonClick, false);
	    }
	
	    carousel.element.toggleClassName('panels-backface-invisible');
	
	    setTimeout( function(){
	      document.body.addClassName('ready');
	    }, 0);
	    var carouselItem = document.getElementById("carousel-container");
	    var carouselHammer = new Hammer(carouselItem);
	
	
	    carouselHammer.on('swipeleft', function(event) {
	          carousel.rotation += carousel.theta * 1 * -1;
	          carousel.transform();
	          carousel.highlightNav(1);
	    });
	
	    carouselHammer.on('swiperight', function(event) {
	      carousel.rotation += carousel.theta * - 1 * -1;
	      carousel.transform();
	      carousel.highlightNav(-1);
	    });
	    $(document).on("click", "#menuDiv figure", function(event) {
	        var index = ((currentIndex > 7) || (currentIndex === 0)) ? 0 : Math.abs(8 - currentIndex);
	
	        var indexurl = $("#menuDiv figure")[index].getAttribute("data-url");
	
	        var sideUrl = event.target.getAttribute('data-url');
	
	        var url = "";
	
	        if(indexurl === sideUrl){
		        window.location.search = `?${indexurl}`;
	        }else{
	          var indexDiff = parseInt(index) -  parseInt(event.target.getAttribute("data-index"));
	          indexDiff = (indexDiff > 1) ? -1 : indexDiff;
	          indexDiff = (indexDiff < -1) ? 1 : indexDiff;
	          carousel.rotation += carousel.theta * indexDiff * -1;
	          carousel.transform();
	          carousel.highlightNav(indexDiff);
	        }
	
	    });
	
	    var isEnabled = false;
	    $(document).on('click', ".carousel-navigation .carouselCircle", function(evtent){
	
	      if(isEnabled){
	       // isEnabled = false;
	        var absCurrentIndex =  ((currentIndex > 7) || (currentIndex === 0)) ? 0 : Math.abs(currentIndex);
	        var index = parseInt(event.currentTarget.getAttribute("data-index"));
	
	        var moveIndex = absCurrentIndex - index;
	
	        var i = 1;
	
	        var comleteTransitionTime = 500 * Math.abs(moveIndex);
	        var comleteTransitionTimeCSS = (comleteTransitionTime/1000)/Math.abs(moveIndex);
	
	        var transitionTime = 1/Math.abs(moveIndex);
	        var intervalTime = comleteTransitionTime/Math.abs(moveIndex);
	
	        $("#carousel").css("transition", "transform " + comleteTransitionTimeCSS + "s ease-in-out");
	        $(".ready #carousel figure").css("transition", "transform " + comleteTransitionTimeCSS + "s ease-in-out, " + "opcaity" + comleteTransitionTimeCSS +"s");
	        var start = null;
	        var completePass = false;
	        var stepMuliplyer = 1;
	
	        function step(timestamp) {
	          if (!start) start = timestamp;
	
	          var progress = timestamp - start;
	
	          if(!completePass){
	
	              if(moveIndex < 0){
	                carousel.rotation += carousel.theta * 1 * -1;
	                carousel.transform();
	                carousel.highlightNavByIndex(index);
	              }else{
	                carousel.rotation += carousel.theta * - 1 * -1;
	                carousel.transform();
	                carousel.highlightNavByIndex(index);
	
	              }
	
	              completePass = true;
	          }
	
	
	          if(progress < comleteTransitionTime){
	            if (progress < (intervalTime * stepMuliplyer)){
	              window.requestAnimationFrame(step)
	            }
	            else{
	                stepMuliplyer++;
	                completePass = false;
	                window.requestAnimationFrame(step)
	            }
	          }
	        }
	
	        window.requestAnimationFrame(step);
	        currentIndex = index;
	      }
	
	    });
	
		// These are the icons above the carousel. don't let 'data-home-button' fool you, these cycle the carousel to the slide indicated by the icon.
	    $(document).on("click", ".data-home-button", function(event){
	      var index = parseInt(event.currentTarget.getAttribute("data-index"));
				// 6 = 2
				// 3 = 5
				// 7 = 1
				// 5 = 4
	      var moveIndex = currentIndex - index;
	      carousel.rotation += carousel.theta * - moveIndex * -1;
	      carousel.transform();
	      carousel.highlightNavByIndex(index);
	    });
	
	    var randomIndex = Math.floor(Math.random() * 8);
	    // var randomIndex = 1;
	    carousel.rotation += carousel.theta * randomIndex * -1;
	    carousel.transform();
	    carousel.highlightNavByIndex(randomIndex);
	    return carousel;
	  };
	
	  function highlightNav(direction){
	
	  }
	
	  function Carousel3D ( el ) {
	      this.element = el;
	
	      this.rotation = 0;
	      this.panelCount = 0;
	      this.totalPanelCount = this.element.children.length;
	      this.theta = 0;
	
	      this.isHorizontal = true;
	
	  }
	
	  Carousel3D.prototype.highlightNav = function(iterateDirection){
	    var index = 0;
	    var items = $(".carouselCircle");
	    for(i=0; i<items.length; i++){
	      if($(items[i])[0].parentElement.className == "selectedCircle"){
	        index = i;
	      }
	    }
	
	    if(iterateDirection == -1){
	      index = index - 1;
	    }
	    else{
	      index = index + 1;
	    }
	
	    if(index > 7){
	      index = 0;
	    }
	    if(index < 0){
	      index = 7;
	    }
	    currentIndex = index;
	    for(j=0; j<items.length; j++){
	      $(items[j])[0].parentElement.className = "selectedCircle";
	      if(j != index){
	        $(items[j])[0].parentElement.className ="";
	      }
	    }
	  }
	
	  Carousel3D.prototype.highlightNavByIndex = function(index){
	    var items = $(".carouselCircle");
	    //console.log(items)
	    for(j=0; j<items.length; j++){
	      //console.log($(items[j]))
	      items[j].parentElement.className = "selectedCircle";
	      if(j != index){
	        items[j].parentElement.className ="";
	      }
	    }
	    currentIndex = index;
	  }
	
	  Carousel3D.prototype.selectRandom = function(){
	      var min = 0;
	      var max = 7;

	      //Get Random Index
// 	      var index = Math.floor(Math.random() * (max - min + 1)) + min;
	      var index = 7;
	      var moveIndex = currentIndex - index;
	      this.rotation += this.theta * - moveIndex * -1;
	      this.transform();
	      this.highlightNavByIndex(index);
	  }
	
	  Carousel3D.prototype.modify = function() {
	
	      var panel, angle, i;
	
	      this.panelSize = this.element[ this.isHorizontal ? 'offsetWidth' : 'offsetHeight' ];
	      this.rotateFn = this.isHorizontal ? 'rotateY' : 'rotateX';
	      this.theta = 360 / this.panelCount;
	
	      // do some trig to figure out how big the carousel
	      // is in 3D space
	      this.radius = Math.round( ( this.panelSize / 2) / Math.tan( Math.PI / this.panelCount ) );
	
	      for ( i = 0; i < this.panelCount; i++ ) {
	        panel = this.element.children[i];
	        angle = this.theta * i;
	       // panel.style.opacity = 1;
	        panel.style.backgroundColor = 'hsla(' + angle + ', 100%, 50%, 1)';
	        // rotate panel, then push it out in 3D space
	        var translation = this.radius/3;
	
	         //alert(transformProp)
	        panel.style[ transformProp ] = this.rotateFn + '(' + angle + 'deg) translateZ(' + (-(translation))+ 'px)';
	        panel.style["transform-style"] =  "preserve-3d";
	
	
	      }
	
	      // hide other panels
	      for (  ; i < this.totalPanelCount; i++ ) {
	        panel = this.element.children[i];
	       // panel.style.opacity = 0;
	        panel.style[ transformProp ] = 'none';
	      }
	
	      // adjust rotation so panels are always flat
	      this.rotation = Math.round( this.rotation / this.theta ) * this.theta;
	
	      this.transform();
	
	  };
	
	  Carousel3D.prototype.transform = function() {
	
	      this.element.style[ transformProp ] =  ' translateZ(' + 0 + 'px) ' + this.rotateFn + '(' + (-this.rotation) + 'deg)';
	      this.element.style["transform-style"] =  "preserve-3d";
	      for ( i = 0; i < this.panelCount; i++ ) {
	          panel = this.element.children[i];
	          var carousel = document.getElementById("carousel");
	          var carosuelTransformStyle = carousel.style.webkitTransform ? carousel.style.webkitTransform : carousel.style.transform;
	          var panelTransformStyle = panel.style.webkitTransform ? panel.style.webkitTransform : panel.style.transform;
	          var carRotY = carosuelTransformStyle.split(" ");
	          var panelRotY = panelTransformStyle.split(" ");
	          var absolutePanel = panelRotY[0].split("-");
	          var minusPanel = absolutePanel.join("");
	          var tempPanelVal = minusPanel.split("(")[1];
	          var panelDegrees = parseFloat(tempPanelVal.split('d'));
	          var absoluteVal = carRotY[1].split("-");
	          var minusRotY = absoluteVal.join("");
	          var tempVal = minusRotY.split("(")[1];
	          var degrees = parseFloat(tempVal.split('d'));
	          var newVal = degrees%360;
	          var string = 'rotateY(' + newVal + 'deg)'
	          //alert(newVal)
	          if(carRotY[1].indexOf("-") > 1){
	          }
	          else{
	              if(panelDegrees == 0){
	                degrees = 0;
	                panelDegrees = 0
	              }else{
	                degrees = 360 - panelDegrees;
	                panelDegrees = 360 - panelDegrees
	              }
	            minusPanel = "rotateY(" + degrees + "deg)";
	          }
	          var deg = (newVal);
	          if(string === minusPanel){
	            $(panel).addClass("full-opacity");
	            panelTransform = panelRotY[0] + " translateZ(0px)";
	            panel.style[ transformProp ]  = panelTransform;
	            $(panel).removeClass("hidden");
	          }
	          else{
	            $(panel).removeClass("full-opacity");
	            var currentPanelRotY = panelTransformStyle.split(" ");
	            panelTransform = currentPanelRotY[0] + " translateZ(-220px)";
	            panel.style[ transformProp ]  = panelTransform;
	          }
	          if((panelDegrees - 45) > deg || (panelDegrees + 45) < deg){
	            $(panel).addClass("hidden");
	          }
	          else{
	            $(panel).removeClass("hidden");
	          }
	
	
	          if(deg == 0 && panelDegrees == 315){
	            $(panel).removeClass("hidden");
	          }
	           if(deg == 315 && panelDegrees == 0){
	            $(panel).removeClass("hidden");
	          }
	      }
	
	  };	
		window.carouselInit = carouselInit;
})();
